import type { SignalStrength } from '../../shared';
import { cn } from '@/lib/utils';

interface SignalIndicatorProps {
  strength: SignalStrength;
  size?: 'sm' | 'md' | 'lg';
}

export function SignalIndicator({ strength, size = 'md' }: SignalIndicatorProps) {
  const colors = {
    1: 'bg-red-500',
    2: 'bg-orange-500',
    3: 'bg-yellow-500',
    4: 'bg-lime-500',
    5: 'bg-green-500',
  };

  const sizeClasses = {
    sm: 'h-2',
    md: 'h-3',
    lg: 'h-4',
  };

  return (
    <div className="flex gap-1">
      {[1, 2, 3, 4, 5].map((level) => (
        <div
          key={level}
          className={cn(
            'w-8 rounded-sm transition-all',
            sizeClasses[size],
            level <= strength ? colors[strength] : 'bg-gray-200'
          )}
        />
      ))}
    </div>
  );
}
